import { Mail, Phone } from "lucide-react";

export function AgentCard({ contact, onRequestShowing, sticky }) {
  if (!contact?.name) return null;
  return (
    <div data-testid="listing-agent-card" className={`rounded-xl border border-[#E7E4DE] bg-white p-5 sm:p-6 ${sticky ? "lg:sticky lg:top-24" : ""}`}>
      <div className="flex items-center gap-4">
        {contact.photo_url
          ? <img src={contact.photo_url} alt={contact.name} className="h-16 w-16 rounded-full object-cover flex-shrink-0" />
          : <div className="h-16 w-16 rounded-full bg-[#F8F7F4] flex items-center justify-center text-[#667085] font-serif-display text-xl flex-shrink-0">{contact.name[0]}</div>}
        <div className="min-w-0">
          <p data-testid="listing-agent-name" className="font-serif-display text-lg text-[#202833] truncate">{contact.name}</p>
          {contact.company && <p className="text-sm text-[#667085] truncate">{contact.company}</p>}
        </div>
      </div>
      <div className="mt-5 flex gap-2.5">
        {contact.phone && <a data-testid="listing-agent-call" href={`tel:${contact.phone}`} className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg bg-[#C7A361] text-[#111820] text-sm font-medium py-2.5 hover:brightness-95 transition"><Phone size={15} />Call Agent</a>}
        <button data-testid="listing-agent-message" onClick={onRequestShowing} className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg border border-[#E7E4DE] text-[#202833] text-sm font-medium py-2.5 hover:bg-[#F8F7F4] transition"><Mail size={15} />Send Message</button>
      </div>
    </div>
  );
}
